import { RegraTributariaNaturezaOperacaoStruct } from '@shared/services/structs/motor-fiscal/regra-tributaria-natureza-operacao.struct';

export class RegraTributariaSelectDialogData {
    titulo: string;
    multiple: boolean;
    selecionadas: RegraTributariaNaturezaOperacaoStruct[];
    regraPadraoId?: number | null;
}
